import { Question, QuestionGroup } from '~/types/QuestionGroup';
import { Uuid } from '~/types/Uuid';

export type QuestionPayload = {
  type: 'questions';
  id: Uuid;
  attributes: {
    name: string;
    text: string;
    created_at: string;
    pinned_at: string | null;
    updated_at: string;
    scope: string;
    pilot_user_id: number;
    question_group_ids: Uuid[] | null;
  };
};

export type QuestionGroupPayload = {
  type: 'question_groups';
  id: Uuid;
  attributes: {
    name: string;
    description: string;
    created_at: string;
    pinned_at: string | null;
    updated_at: string;
    pilot_user_id: number;
    updated_by_user_id: number;
    question_ids: Uuid[] | null;
    visibility: 'OPEN' | 'PRIVATE' | 'SHARED';
    user_ids: number[];
    department_ids: number[];
  };
};

export interface QuestionResponsePayload {
  data: QuestionPayload;
}

export interface QuestionsResponsePayload {
  data: QuestionPayload[];
}

export interface QuestionGroupResponsePayload {
  data: QuestionGroupPayload;
}

export interface QuestionGroupsResponsePayload {
  data: QuestionGroupPayload[];
}

export const mapQuestionResponse = (question: QuestionPayload): Question => {
  const {
    attributes: {
      pilot_user_id: createdBy,
      created_at,
      pinned_at,
      name,
      text,
      updated_at,
      scope,
      question_group_ids,
    },
  } = question;

  return {
    id: question.id,
    createdAt: new Date(created_at),
    createdBy,
    name,
    pinnedAt: pinned_at ? new Date(pinned_at) : null,
    questionGroupIds: question_group_ids ?? [],
    scope,
    text,
    updatedAt: new Date(updated_at),
  } as Question;
};

export const mapQuestionGroupResponse = (
  questionGroup: QuestionGroupPayload,
): QuestionGroup => {
  const {
    attributes: {
      created_at,
      description,
      name,
      pinned_at,
      updated_at,
      pilot_user_id: createdBy,
      updated_by_user_id: updatedBy,
      question_ids: questionIds,
      visibility,
      user_ids: userIds,
      department_ids: departmentIds,
    },
  } = questionGroup;

  return {
    id: questionGroup.id,
    createdAt: new Date(created_at),
    createdBy,
    description,
    name,
    pinnedAt: pinned_at ? new Date(pinned_at) : null,
    questionIds: questionIds ?? [],
    updatedAt: new Date(updated_at),
    updatedBy,
    visibility: visibility ?? 'PRIVATE',
    userIds: userIds ?? [],
    departmentIds: departmentIds ?? [],
  } as QuestionGroup;
};
